import React, { useState } from "react";
import GlobalStyles, { CommonClasses } from "../../global/GlobalStyles";
import { Link, useNavigate } from "react-router-dom";
import { FaCalendarAlt, FaSearch } from "react-icons/fa";
import { HiMiniBuildingOffice2 } from "react-icons/hi2";
import { SiteName } from "../../global/SiteName";
import toast from "react-hot-toast";

const Track = ({ options }) => {
  const [trackingId, setTrackingId] = useState("");
  const navigate = useNavigate();
  const handleSubmit = () => {
    const tracking_id = trackingId;
    if (!trackingId) {
      toast.error("Please enter a tracking ID");
      return;
    }
    navigate(`/track/${tracking_id}`);
  };
  const handlePress = () => {
    toast("This feature will be available soon.");
  };
  return (
    <div className="w-full h-screen bg-default bg-center bg-cover lg:bg-fixed">
      <div className="w-full h-full bg-black/70 flex flex-col justify-center items-center gap-10">
        <h2 className={GlobalStyles.headerPrimary}>Track Your Shipment</h2>
        <div className={`${GlobalStyles.searchContainer2}`}>
          <FaSearch className={GlobalStyles.searchIcon} />
          <input
            type="text"
            placeholder="Enter your tracking number"
            className={GlobalStyles.searchInput}
            value={trackingId}
            onChange={(e) => setTrackingId(e.target.value)}
          />
          <button onClick={handleSubmit} className={GlobalStyles.button}>
            Track
          </button>
        </div>
        {options && (
          <div className="flex items-center">
            <Link
              to={`/ship`}
              className={`w-36 h-32 bg-primary hover:bg-primary/70 flex items-center p-2 flex-col justify-center text-white gap-2 ${CommonClasses.transition} lg:hover:scale-105`}
            >
              <FaCalendarAlt className="text-4xl" />
              <span className="text-sm font-semibold text-center">
                Ship now
              </span>
            </Link>
            <button
              className={`w-36 h-36 bg-secondary hover:bg-secondary/70 flex items-center p-2 flex-col justify-center text-white gap-2 ${CommonClasses.transition} lg:hover:scale-105`}
              onClick={handlePress}
            >
              <HiMiniBuildingOffice2 className="text-4xl" />
              <span className="text-sm font-semibold text-center">
                {SiteName} for businness
              </span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Track;
